// Vendor
import * as React from 'react';
import { SPOT_GREY_7 } from '@thredup/styleguide/src/variables/colors';

export interface MenuProps {
  className?: string;
  height?: number;
  id?: string;
  stroke?: string;
  width?: number;
}

/**
 * @name Menu
 * @description thredUP Menu
 */
const Menu: React.FC<MenuProps> = (props) => {
  const { className, height, id, stroke, width } = props;

  return (
    <svg
      aria-labelledby={id}
      className={className}
      height={height}
      role="img"
      viewBox="0 0 27 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={id}>Menu</title>
      <desc>Menu</desc>
      <g fill="none" fillRule="evenodd" stroke={stroke} strokeWidth="1.802">
        <rect width="24.627" height="1" x=".901" y=".901" rx=".5" />
        <rect width="24.627" height="1" x=".901" y="9.686" rx=".5" />
        <rect width="24.627" height="1" x=".901" y="17.795" rx=".5" />
      </g>
    </svg>
  );
};

Menu.defaultProps = {
  stroke: SPOT_GREY_7,
  height: 27,
  id: 'thredup-Menu-icon',
  width: 20
};

export { Menu };
